module.exports = __webpack_public_path__ + "media/images/icons/logoBI-iniciosesion-2988b0d7deebae413e34a95a719b03e0.svg";